class AnalyticsClientError extends Error {
	constructor(message) {
		super(message);
		this.name = 'AnalyticsClientError';
	}
}

export default AnalyticsClientError;
